import React, { createContext, useState, useContext, useEffect } from "react";
import { login as loginService, logoutUser } from "../services/authService";
import api from "../services/api";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Function to fetch the current user data
  const fetchUser = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.data);
    } catch (error) {
      console.error("Failed to fetch user:", error);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

   // Handle login + fetch user details in one place
   const handleLogin = async (email, password) => {
    setLoading(true);
    try {
      const { accessToken, refreshToken } = await loginService(email, password);
      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('refreshToken', refreshToken);
  
      const { data } = await api.get('/auth/me');
      setUser(data.data);
  
      return data.data;
    } finally {
      setLoading(false);
    }
  };

  // Logout function
  const handleLogout = async () => {
    await logoutUser();
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    setUser(null);
  };

  // Refresh token and fetch user data on app load or token refresh
  useEffect(() => {
    const initializeAuth = async () => {
      const accessToken = localStorage.getItem("accessToken");
      if (accessToken) {
        try {
          await fetchUser(); // Fetch user data if token exists
        } catch {
          handleLogout(); // Logout if fetching user fails
        }
      } else {
        setLoading(false);
      }
    };
    initializeAuth();
  }, []);

  return (
    <AuthContext.Provider value={{ user, login: handleLogin, logout: handleLogout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
